export const FETCH_OT_EMP_NOTLEFT_REQUEST = "FETCH_OT_EMP_NOTLEFT_REQUEST";
export const FETCH_OT_EMP_NOTLEFT_SUCCESS = "FETCH_OT_EMP_NOTLEFT_SUCCESS";
export const FETCH_OT_EMP_NOTLEFT_FAILURE = "FETCH_OT_EMP_NOTLEFT_FAILURE";